import React, { useState } from 'react';

const Options = ({ handleServiceSelect }) => {
  const [selectedService, setSelectedService] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleServiceSelect2 = async (service) => {
    setIsLoading(true);
    setSelectedService(service);
    setError(null);

    try {
      // Simulate an API call or some async operation
      handleServiceSelect(service);
    } catch (err) {
      setError('An error occurred while selecting the service.');
    } finally {
      setIsLoading(false);
    }
  }

  const serviceOptions = [
    {
      id: 'investors',
      title: 'Investors',
      icon: 'https://img.icons8.com/external-flatart-icons-outline-flatarticons/64/external-investor-seo-flatart-icons-outline-flatarticons.png',
      alt: 'investor icon',
      type: 'investors'
    },
    {
      id: 'funding-agencies',
      title: 'Funding Agencies',
      icon: 'https://img.icons8.com/external-goofy-line-kerismaker/96/external-Agency-marketing-goofy-line-kerismaker.png',
      alt: 'funding agency icon',
      type: 'funding_agencies'
    },
    {
      id: 'standards',
      title: 'Standards',
      icon: 'https://img.icons8.com/ios/50/department.png',
      alt: 'standards icon',
      type: 'standards'
    }
  ];

  return (
    <div className="mt-16 mb-8 w-full">
      {error && (
        <div className="text-red-500 text-center mb-4">{error}</div>
      )}
      
      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-5 mt-5 max-w-[1200px] mx-auto">
        {serviceOptions.map((option) => (
          <div 
            key={option.id}
            onClick={() => !isLoading && handleServiceSelect2(option.title)}
            className={`shadow-lg hover:shadow-xl hover:bg-[#4482fa] hover:text-black bg-[#2a2a39] cursor-pointer rounded-xl p-5 
              ${selectedService === option.title ? 'bg-[#4482fa] text-black' : ''}
              ${isLoading ? 'opacity-75 cursor-wait' : ''}`}
          >
            <div className="flex justify-center items-center">
              <img 
              className='filter invert brightness-110 contrast-125'
                width="50" 
                height="50" 
                src={option.icon} 
                alt={option.alt}
              />
            </div>
            <h3 className="text-base md:text-xl text-center font-semibold mt-5 text-white">
              {option.title}
              {isLoading && selectedService === option.title && (
                <span className="ml-2 inline-block animate-spin">⟳</span>
              )}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Options;